




import Vue from 'vue';
import MaterialDbDelete from '@/components/material-db/material-db-delete.component.vue';

export default Vue.extend({
  components: {
    'material-db-delete': MaterialDbDelete,
  },
});
